(function () {
  'use strict';

  var ROOT = '.gw-landing';
  var FRAME_IMGS =
    ROOT +
    ' .gw-collection-card__media img, ' +
    ROOT +
    ' .gw-room-card__media img, ' +
    ROOT +
    ' .gw-collectors__item img';

  function markFrameLoaded(img) {
    img.classList.add('loaded');
  }

  function initLazyFrames() {
    document.querySelectorAll(FRAME_IMGS).forEach(function (img) {
      if (img.classList.contains('loaded')) return;
      if (img.complete) {
        markFrameLoaded(img);
        return;
      }
      img.addEventListener(
        'load',
        function () {
          markFrameLoaded(img);
        },
        { once: true }
      );
      img.addEventListener(
        'error',
        function () {
          markFrameLoaded(img);
        },
        { once: true }
      );
    });
  }

  function initReveal() {
    var nodes = document.querySelectorAll(ROOT + ' .gw-reveal');
    if (!nodes.length || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.1 }
    );

    nodes.forEach(function (el) {
      observer.observe(el);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector(ROOT)) return;
    initLazyFrames();
    initReveal();
  });
})();
